<template>
  <div>
    <b-row>
      <b-col>
        <h5>Filtrar por</h5>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaDesde">Fecha desde</label>
          <b-form-input
            type="date"
            id="txtFechaDesde"
            v-model="range.startDate"
            :max="range.endDate == '' ? maxDate : range.endDate"
            @blur="changeDateImport()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaHasta">Fecha hasta</label>
          <b-form-input
            type="date"
            id="txtFechaHasta"
            v-model="range.endDate"
            :min="range.startDate"
            :max="maxDate"
            @blur="changeDateImport()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col sm="2">
        <b-form-group>
          <label class="mb-0">Estado</label>
          <b-form-select v-model="statusFilter" @change="getCustomers()">
            <template slot="first">
              <option :value="null">-- Estado--</option>
            </template>
            <option value="P">Por activar</option>
            <option value="A">Activo</option>
            <option value="I">Inactivo</option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Avance</label>
          <b-form-select v-model="advance" @change="getAdvanceLevel()">
            <template slot="first">
              <option :value="null">-- Avance --</option>
            </template>
            <option v-for="item in lstAdvance" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Grado avance</label>
          <b-form-select
            v-model="advance_level"
            @change="getCustomers()"
            :disabled="advance == null"
          >
            <template slot="first">
              <option :value="null">-- Grado avance --</option>
            </template>
            <option
              v-for="item in lstAdvanceLevel"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col v-if="role_id == 1 || role_id == 7">
        <!-- <b-col> -->
        <b-form-group>
          <label class="mb-0">Comercial</label>
          <b-form-select v-model="staff_idFilter" @change="getCustomers()">
            <template slot="first">
              <option :value="null">-- Comercial--</option>
            </template>
            <option v-for="item in lstStaffs" :key="item.id" :value="item.id">
              {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaGestionDesde"
            >Fecha gestión desde</label
          >
          <b-form-input
            type="date"
            id="txtFechaGestionDesde"
            v-model="range_task_management.startDate"
            :max="
              range_task_management.endDate == ''
                ? maxDate
                : range_task_management.endDate
            "
            @blur="changeDateTask()"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaGestionHasta"
            >Fecha gestión hasta</label
          >
          <b-form-input
            type="date"
            id="txtFechaGestionHasta"
            v-model="range_task_management.endDate"
            :min="range_task_management.startDate"
            :max="maxDate"
            @blur="changeDateTask()"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card :header="caption">
            <b-table
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive
              :items="filteredItems()"
              :fields="fieldsSelected"
              :filter="filter"
              :current-page="currentPage"
              :per-page="perPage"
            >
              <!-- <template :slot="`HEAD_${ key }`" v-for="key in fieldKeys()" slot-scope="data">
            <b>{{ data.label }}</b>
            <select class="form-control form-control-sm" @click.stop.prevent v-model="selectVal[key]">
            <option :value="undefined">Seleccionar...</option>
            <option :value="option" v-for="option in options()[key]" :key="option">{{ option }}</option>
          </select>
            </template>-->

              <template slot="HEAD_selected" v-if="isAdmin">
                <input
                  type="checkbox"
                  @click.stop
                  v-model="selectAll"
                  @change="toggleSelectAll"
                />
              </template>

              <template slot="selected" slot-scope="data" v-if="isAdmin">
                <input
                  type="checkbox"
                  v-model="data.item.selected"
                  @change="selectRow(data.item)"
                />
              </template>

              <template slot="status" slot-scope="data">
                <b-badge :variant="getBadge(data.item.status)">{{
                  getTextStatus(data.item.status)
                }}</b-badge>
              </template>

              <template slot="actions" slot-scope="data">
                <b-button
                  size="sm"
                  variant="primary"
                  class="mr-1 btn-custom-size"
                  @click="viewCustomer(data.item.id)"
                  title="Gestionar"
                >
                  <i class="fa fa-eye"></i>
                </b-button>
              </template>
            </b-table>
            <hr />
            <div class="row">
              <div class="col-sm-4">
                Mostrando
                {{
                  filteredItems().length > perPage * currentPage
                    ? perPage * currentPage
                    : filteredItems().length
                }}
                de {{ filteredItems().length }} registros
              </div>
              <div class="col-sm-8">
                <nav>
                  <b-pagination
                    align="right"
                    size="sm"
                    :total-rows="
                      filteredItems().length == null
                        ? 0
                        : filteredItems().length
                    "
                    :per-page="perPage"
                    v-model="currentPage"
                    prev-text="Anterior"
                    next-text="Siguiente"
                    :limit="10"
                  />
                </nav>
              </div>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker"; //https://github.com/Innologica/vue2-daterange-picker/blob/master/src/components/DateRangePicker.vue
import moment from "moment";
export default {
  name: "customers",
  components: { DateRangePicker },
  props: {
    caption: {
      type: String,
      default: "CUENTAS",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      range: {
        // startDate: sumarDias(new Date(), -30), endDate: new Date()
        startDate: moment(String(sumarDias(new Date(), -30))).format(
          "YYYY-MM-DD"
        ),
        endDate: moment(String(new Date())).format("YYYY-MM-DD"),
      },
      range_task_management: {
        startDate: null,
        endDate: null,
      },

      tableData: [],
      tableHeader: [],
      token: localStorage.getItem("token"),
      auth: localStorage.getItem("auth"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      selectAll: false,
      status: null,
      staff_id: null,
      customer_id: null,
      customer_name: null,
      fields: [
        // {key: 'selected', name:'Selected', label: '', class: 'options-column'},
        { key: "status", name: "Estado", label: "Estado" },
        { key: "advance_name", name: "Avance", label: "Avance" },
        { key: "advance_level_name", name: "Nivel", label: "Nivel" },
        {
          key: "business_name",
          name: "Empresa",
          label: "Empresa",
          sortable: true,
        },
        {
          key: "initial_call",
          name: "Llamada Inicial",
          label: "Llamada Inicial",
          sortable: true,
        },
        {
          key: "send_presentation",
          name: "Presentación",
          label: "Presentación",
          sortable: true,
        },
        {
          key: "tracking_call",
          name: "Llamada de seguimiento",
          label: "Llamada seg.",
          sortable: true,
        },
        { key: "visit", name: "Visita", label: "Visita", sortable: true },
        {
          key: "contract",
          name: "Contrato",
          label: "Contrato",
          sortable: true,
        },
        { key: "wallet", name: "Cartera", label: "Cartera", sortable: true },
        {
          key: "actions",
          name: "Opciones",
          label: "Opciones",
          $isDisabled: true,
        },
      ],
      items: [],
      selectItems: [],
      lstStaffs: [],
      pagination: {},
      rowCount: -1,
      mostrarResumen: false,
      fieldsSelected: [],
      selectVal: {},
      filter: null,
      lstAdvance: [],
      lstAdvanceLevel: [],
      statusFilter: null,
      staff_idFilter: null,
      advance: null,
      advance_level: null,
      business_name: null,
      errores: [],

      currentPage: 1,
      perPage: 10,
    };
  },
  mounted() {
    this.fieldsSelected = this.fields;
    this.getCustomers();

    //LISTADO DE STAFF'S: 42: COMERCIAL
    this.$http.get(`${this.$urlApi}staffs/type/42?token=${this.token}`).then(
      (response) => {
        this.lstStaffs = response.data.data;
        // console.log(response.data.data);
      },
      (error) => {
        console.log(error);
      }
    );

    // 4: AVANCE CLIENTE
    this.$http.get(`${this.$urlApi}parameters/4?token=${this.token}`).then(
      (response) => {
        this.lstAdvance = response.data.data;
      },
      (error) => {
        console.log(error);
      }
    );
  },
  methods: {
    filteredItems() {
      return this.items.filter((item) => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.fieldKeys().forEach((key) => {
          keep =
            keep &&
            (this.selectVal[key] === undefined ||
              item[key] === this.selectVal[key]);
        });
        return keep;
      });
    },
    fieldKeys() {
      let keys = [
        "status",
        "advance_name",
        "advance_level_name",
        "initial_call",
        "send_presentation",
        "tracking_call",
        "visit",
        "contract",
        "wallet",
      ];
      return keys;
      // if(this.items[0] === undefined) return null
      // else return Object.keys(this.items[0]);
    },
    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      //console.log(this.fieldKeys())
      this.fieldKeys().forEach((key) => {
        const vals = this.items.map((item) => item[key]);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals));
      });

      return options;
    },
    changeDateImport() {
      if (this.range.startDate != "" && this.range.endDate != "") {
        this.getCustomers();
      } else return;
    },
    changeDateTask() {
      if (
        this.range_task_management.startDate != "" &&
        this.range_task_management.startDate != null &&
        this.range_task_management.endDate != "" &&
        this.range_task_management.endDate != null
      ) {
        this.getCustomers();
      } else return;
    },
    getCustomers: function () {
      showLoader();

      let authAux = JSON.parse(this.auth);

      authAux[0].status = this.statusFilter;
      authAux[0].filter_staff_id = this.staff_idFilter;
      authAux[0].advance = this.advance;
      authAux[0].advance_level = this.advance_level;
      authAux[0].business_name = this.business_name;
      authAux[0].start_date = moment(this.range.startDate).format("YYYY-MM-DD");
      authAux[0].end_date = moment(this.range.endDate).format("YYYY-MM-DD");

      if (
        this.range_task_management.startDate != "" &&
        this.range_task_management.startDate != null &&
        this.range_task_management.endDate != "" &&
        this.range_task_management.endDate != null
      ) {
        authAux[0].start_date_task_management = moment(
          this.range_task_management.startDate
        ).format("YYYY-MM-DD");
        authAux[0].end_date_task_management = moment(
          this.range_task_management.endDate
        ).format("YYYY-MM-DD");
      }

      // ARMAR LA URL CON LA PAGINACIÓN
      let url = `${this.$urlApi}customers/filterindicators?token=${this.token}`;

      if (this.role_id != 1 && this.role_id != 7) {
        authAux[0].filter_staff_id = authAux[0].staff_id;
      }

      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            this.items = response.data.data;
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getBadge(status) {
      return getBadge(status);
    },
    getTextStatus(status) {
      return getTextStatus(status);
    },
    selectRow(item) {
      if (!item.selected) {
        if (this.selectAll) {
          this.selectAll = false;
        }
        var index = this.selectItems.indexOf(item);

        if (index > -1) {
          this.selectItems.splice(index, 1);
        }
      } else {
        this.selectItems.push(item);
      }
      //console.log(this.selectItems)
    },
    toggleSelectAll() {
      if (this.selectAll) {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = true;
          this.$set(this.items, i, updatingItem);
          this.selectItems.push(updatingItem);
        }
      } else {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = false;
          this.$set(this.items, i, updatingItem);
        }
        this.selectItems = [];
      }
      //console.log(this.selectItems)
    },
    startDownload() {
      showLoader();
    },
    finishDownload() {
      hideLoader();
    },
    viewCustomer(id) {
      let url = `${location.origin}/#/customers/view/${id.toString()}`;
      window.open(url, "_blank");
    },
    getAdvanceLevel() {
      this.advance_level = null;
      this.getCustomers();

      this.$http
        .get(
          `${this.$urlApi}parameters/advance/${this.advance}?token=${this.token}`
        )
        .then(
          (response) => {
            this.lstAdvanceLevel = response.data.data;
          },
          (error) => {
            console.log(error);
          }
        );
    },
  },
};
</script>
